import { dow_labels, hour_labels } from './helper/data.mjs';
/*
const dow_labels = {
  short_by_index: {
    1: 'L.',
    2: 'M.',
    3: 'M.',
    4: 'J.',
    5: 'V.',
    6: 'S.',
    7: 'D.',
  },
  full_by_index: {
    0: 'Lundi',
    1: 'Mardi',
    2: 'Mercredi',
    3: 'Jeudi',
    4: 'Vendredi',
    5: 'Samedi',
    6: 'Dimanche',
  },
};

const hour_labels = Array(24)
  .fill()
  .map((v, i) => {
    const lbl = `${i.toString().padStart(2, '0')}H`;
    return lbl;
  });
*/

export const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(45, 195, 125)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)',
};

const prepare_chart_data = (data, period) => {
  if (period === 'daily') {
    return prepare_chart_data_day(data);
  }
  if (period === 'weekly') {
    return prepare_chart_data_week(data);
  }
  if (period === 'yearly') {
    return prepare_chart_data_year(data);
  }
};

const prepare_chart_data_day = (distrib) => {
  let labels = [];
  let values = [];
  labels = Array(24)
    .fill()
    .map((v, i) => {
      //let to_time = (i + 1) % 24;
      //const lbl = `${i.toString().padStart(2, '0')}-${to_time.toString().padStart(2, '0')}`;
      const lbl = `${i.toString().padStart(2, '0')}`;
      return lbl;
    });
  values = Array(24).fill(0);
  Object.entries(distrib).forEach(([key, value]) => {
    values[+key] = value;
  });
  return { labels, values };
};

const prepare_chart_data_week = (distrib) => {
  let labels = [];
  let values = [];
  Object.entries(distrib).forEach(([key, value]) => {
    labels.push(dow_labels.short_by_index[key]);
    values.push(value);
  });
  return { labels, values };
};

const prepare_chart_data_year = (distrib) => {
  let labels = [];
  let values_ = Array(52 - 1 + 1)
    .fill()
    .map((_, idx) => {
      const key = 1 + idx;
      return {
        x: moment().isoWeek(+key),
        y: 0,
      };
    });

  Object.entries(distrib).forEach(([key, value]) => {
    let wm_date = moment().isoWeek(+key);
    values_[+key - 1] = {
      x: wm_date,
      y: value,
    };
  });
  const vv = Object.entries(distrib).map((v) => v[1]);
  const average = ss.average(vv);
  labels = values_.map((d) => d.x);
  const averages = values_.map((v) => {
    return { x: v.x, y: average };
  });
  return { labels, values: values_, averages };
};

export const render_hoddow_mx_chart = (hoddow_data, chart_opts) => {
  const max_values = Math.max(...hoddow_data.map((c) => c.v));
  hoddow_data.forEach((c) => {
    c.v /= max_values;
  });
  const data = {
    datasets: [
      {
        label: 'Footfall Heatmap',
        data: hoddow_data,
        backgroundColor: (context) => {
          const value = context.dataset.data[context.dataIndex].v;
          return d3.interpolateYlOrRd(value);
        },
        borderColor: (context) => {
          const value = context.dataset.data[context.dataIndex].v;
          return d3.interpolateYlOrRd(value);
        },
        borderWidth: 1,
        /*
          width: () => {
            return 22;
          },
          height: () => {
            return 22;
          },
          */
        width: ({ chart }) => (chart.chartArea || {}).width / 24 - 1,
        height: ({ chart }) => (chart.chartArea || {}).height / 7 - 1,
      },
    ],
  };
  const chartAreaBorder = {
    id: 'chartAreaBorder',
    beforeDraw(chart, args, options) {
      const {
        ctx,
        chartArea: { left, top, width, height },
      } = chart;
      ctx.save();
      ctx.strokeStyle = options.borderColor;
      ctx.lineWidth = options.borderWidth;
      ctx.setLineDash(options.borderDash || []);
      ctx.lineDashOffset = options.borderDashOffset;
      ctx.strokeRect(left, top, width, height);
      ctx.restore();
    },
  };
  const tick_font_size = 10;
  const config = {
    type: 'matrix',
    data: data,
    options: {
      plugins: {
        legend: false,
        tooltip: {
          enabled: false,
        },
        chartAreaBorder: {
          borderColor: 'lightgray',
          borderWidth: 1,
        },
      },
      scales: {
        x: {
          type: 'category',
          labels: hour_labels,
          offset: true,
          ticks: {
            display: true,
            font: {
              size: tick_font_size,
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          type: 'category',
          labels: Object.values(dow_labels.short_by_index)
            .sort((a, b) => a.index - b.index)
            .map((l) => l.label)
            .reverse(),
          offset: true,
          ticks: {
            display: true,
            font: {
              size: tick_font_size,
            },
          },
          grid: {
            display: false,
          },
        },
      },
      layout: {
        padding: 0,
      },
    },
    plugins: [chartAreaBorder],
  };

  $(`#${chart_opts.chart_container}`)
    .empty()
    .append(
      $(`
          <div id="${chart_opts.chart_div_id}" style="position: relative; height:100%; width:100%;"/>
          </div>`)
    );
  let $chart_div = $(`#${chart_opts.chart_div_id}`);
  const c_width = parseInt($chart_div.width());
  const c_height = parseInt($chart_div.height());
  let $chart_canvas = $(`<canvas id="${chart_opts.chart_canvas_id}" width="${c_width}" height="${c_height}"></canvas>`);
  $chart_div.append($chart_canvas);
  let the_chart = new Chart($chart_canvas, config);
  return the_chart;
};

export const render_timeseries_chart = (labels, datasets, container_id, options = {}) => {
  const chart_data = {
    labels: labels,
    datasets: datasets,
  };
  let plugins_options = {
    ...{
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
    ...options.plugins,
  };
  /*
  if (options.tooltip) {
    chart_options_plugins.tooltip = options.tooltip;
  }
  */
  const scales_options = {
    ...{
      x: {
        type: 'time',
        time: {
          unit: 'week',
          displayFormats: {
            week: 'MMM',
          },
        },
      },
      y: {
        display: false,
      },
    },
    ...options.scales,
  };
  const config = {
    type: 'line',
    data: chart_data,
    options: {
      maintainAspectRatio: false,
      plugins: plugins_options,
      scales: scales_options,
      elements: {
        line: {
          tension: 0.5,
        },
      },
    },
  };
  let ctnr = $(`#${container_id}`).empty();
  let w = ctnr.width();
  let h = ctnr.height();
  let chart_canvas = $(`<canvas id="${container_id}-chart" width="${w}" height="${h}"></canvas>`);
  ctnr.append(chart_canvas);
  let the_chart = new Chart(chart_canvas, config);
  return the_chart;
};

const render_bar_chart = (labels, datasets, container_id, options = {}) => {
  const chart_data = {
    labels: labels,
    datasets: datasets,
  };
  let chart_options_plugins = {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
  };
  if (options.tooltip) {
    chart_options_plugins.tooltip = options.tooltip;
  }
  if (options.title) {
    chart_options_plugins.title = options.title;
  }

  let scales_options = {
    y: {
      display: false,
    },
    x: {
      ticks: {
        autoSkip: true,
      },
    },
  };
  if (options.scales) {
    scales_options = { ...scales_options, ...options.scales };
  }
  let final_chart_options_options = {
    maintainAspectRatio: false,
    plugins: chart_options_plugins,
    scales: scales_options,
  };

  final_chart_options_options = { ...final_chart_options_options, ...options.main_options };
  /*
  if (options.indexAxis) {
    final_chart_options_options.indexAxis = options.indexAxis;
  }
  */
  const config = {
    type: 'bar',
    data: chart_data,
    options: final_chart_options_options,
  };
  let ctnr = $(`#${container_id}`).empty();
  let w = ctnr.width();
  let h = ctnr.height();
  let chart_canvas = $(`<canvas id="${container_id}-chart" width="${w}" height="${h}"></canvas>`);
  ctnr.append(chart_canvas);
  let the_chart = new Chart(chart_canvas, config);
  return the_chart;
};

export const render_frequency_charts = ({ labels, datasets }, container_id, options = {}) => {
  return render_bar_chart(labels, datasets, container_id, options);
};

export const render_hoddow_chart = ({ labels, datasets }, container_id, options = {}) => {
  return render_bar_chart(labels, datasets, container_id, options);
};

export const build_footfall_chart = (data, period, container_id) => {
  const { labels, values, averages } = prepare_chart_data(data, period);
  let chart_options = {
    data_label: '# passants (normalisé)',
  };
  switch (period) {
    case 'weekly':
      chart_options.title = 'Pour une semaine typique';
      break;
    case 'daily':
      chart_options.title = 'Pour une journée typique';
      break;
    default:
      chart_options.title = 'Pour une année typique';
  }
  if (period === 'yearly') {
    const year_dataset = [
      {
        label: chart_options.title,
        backgroundColor: CHART_COLORS.red,
        borderColor: CHART_COLORS.red,
        borderWidth: 1,
        fill: false,
        data: values,
        pointRadius: 1,
      },
      {
        label: chart_options.title,
        backgroundColor: CHART_COLORS.orange,
        borderColor: CHART_COLORS.orange,
        borderWidth: 1,
        fill: false,
        data: averages,
        pointRadius: 0,
      },
    ];
    const tooltip_title_cb = (tooltip_items) => {
      return `S-${tooltip_items[0].raw.x.isoWeek()}`;
    };
    const tooltip_label_cb = (context) => {
      return `# Visites normalisé: ${context.parsed.y}`;
    };
    const tooltip_options = {
      callbacks: {
        title: tooltip_title_cb,
        label: tooltip_label_cb,
      },
    };
    const chart_plugins_options = {
      tooltip: tooltip_options,
    };
    return render_timeseries_chart(labels, year_dataset, container_id, chart_plugins_options);
  }
  // case of daily or hourly
  const datasets = [
    {
      label: chart_options.title,
      data: values,
      borderColor: CHART_COLORS.green,
      backgroundColor: CHART_COLORS.green,
      borderWidth: 2,
      borderRadius: 2,
      borderSkipped: false,
    },
  ];

  const tooltip_label_cb = (context) => {
    return `# Visites normalisé: ${context.parsed.y}`;
  };
  let tooltip_options = {
    callbacks: {
      label: tooltip_label_cb,
    },
  };
  if (period === 'daily') {
    const tooltip_title_daily_cb = (tooltip_items) => {
      const from_time = tooltip_items[0].parsed.x;
      let to_time = (from_time + 1) % 24;
      const lbl = `${from_time.toString().padStart(2, '0')}h-${to_time.toString().padStart(2, '0')}h`;
      return lbl;
    };
    tooltip_options.callbacks.title = tooltip_title_daily_cb;
  }
  if (period === 'weekly') {
    const tooltip_title_weekly_cb = (tooltip_items) => {
      return dow_labels.full_by_index[tooltip_items[0].parsed.x];
    };
    tooltip_options.callbacks.title = tooltip_title_weekly_cb;
  }

  const chart_plugins_options = {
    tooltip: tooltip_options,
  };
  return render_bar_chart(labels, datasets, container_id, chart_plugins_options);
};
